import { InfoList, Theme, DeprecatedTooltip } from "@landtechnologies/components";

export interface RecordItemProps {
  title: string | JSX.Element[];
  value?: string | JSX.Element | JSX.Element[];
  tooltip?: string;
}
export const RecordItem = ({ title, value, tooltip }: RecordItemProps) => {
  if (value && tooltip) {
    return (
      <InfoList.Item data-testid="record-item">
        <InfoList.ItemTitle>{title}</InfoList.ItemTitle>
        <InfoList.ItemValue className="atlas-text-content-link">
          <DeprecatedTooltip theme={Theme.Dark} placement="top" description={tooltip}>
            {value}
          </DeprecatedTooltip>
        </InfoList.ItemValue>
      </InfoList.Item>
    );
  }
  if (value) {
    return (
      <InfoList.Item data-testid="record-item">
        <InfoList.ItemTitle>{title}</InfoList.ItemTitle>
        <InfoList.ItemValue>{value}</InfoList.ItemValue>
      </InfoList.Item>
    );
  }
  return null;
};
